module.exports = __webpack_public_path__ + "static/media/workAntihumidity10.93a57948.jpg";